import React from 'react'

import Paragraph, { Theme as ParagraphTheme } from 'components/base/Paragraph'
import { SectionRuleContent } from 'components/base/SectionRule/styles'
import Columns from 'components/base/Columns'
import Column from 'components/base/Columns/Column'
import List, { Theme as ListTheme }  from 'components/base/List'
import Text from 'components/base/Text'
import RSVPForm from 'components/blocks/RSVPForm'

import FlexContent from 'components/base/FlexContent'
import { RSVPIcon } from 'components/base/Icon/styles'

interface Meeting {
  title: string,
  date: string,
  time: string,
  location: string,
  address: string,
  city: string,
}

interface EventDetailsProps {
  meetings: Meeting[],
  location: string,
  locationPhoneNumber: string,
}

const EventDetails: React.FC<EventDetailsProps> = ({
  meetings, location, locationPhoneNumber,
}) => {
  return (
    <>
      <Columns>
        <Column flexSize={2}>
          <Paragraph theme={ParagraphTheme.medium}>
            At UnitedHealthcare<sup>®</sup>, we offer many Medicare Advantage plans, including plans for those who qualify for Medicaid. Come and join the fun while discovering the right Medicare plan for you. During this event, you can:
          </Paragraph>
          <List hasMarginBottom={false} theme={ListTheme.medium}>
            <li>Enjoy light refreshments and snacks</li>
            <li>Listen to a presentation on Medicare plans</li>
            <li>Get your questions answered face to face</li>
          </List>
          <SectionRuleContent />
          <FlexContent
            flexDirection='row'
            flexNoWrap={true}
            justifyContent='flex-start'
            alignItems='flex-start'
            hasGutter={false}
            gap='10px'
            margined={true}
            marginSize='small'
          >
            <RSVPIcon />
            <Text weight='bold' color='BLUE' size='xlarge'>Please RSVP as space is limited.</Text>
          </FlexContent>
          <Paragraph theme={ParagraphTheme.medium}>Admission is free of cost. We look forward to seeing you.</Paragraph>
          <Paragraph theme={ParagraphTheme.medium}>
            <strong>Insurance Lounge</strong><br />
            Licensed Sales Agents<br />
            <strong>{locationPhoneNumber},</strong> TTY <strong>711</strong><br />
            Support@InsuranceLounge.com<br />
            www.InsuranceLounge.com
          </Paragraph>
          <FlexContent justifyContent='flex-start' padded={false} hasGutter={false}>
            <RSVPForm location={location} />
          </FlexContent>
        </Column>
        <Column backgroundColor='BGRBLUE'>
          {meetings.map((meeting, index) => (
            <Paragraph key={index} theme={ParagraphTheme.small}>
              <strong>{meeting.title}</strong><br />
              <strong>{meeting.date}</strong><br />
              <strong>{meeting.time}</strong><br />
              {meeting.location}<br />
              {meeting.address}<br />
              {meeting.city}
            </Paragraph>
          ))}
        </Column>
      </Columns>
    </>
  )
}

export default EventDetails
